import {
  ForwardedRef,
  Ref,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import ReactPlayer from "react-player";
import { OnProgressProps } from "react-player/base";
import useHomeworkState from "../state/homework.state";
import AudioManager, { AudioManagerHandle } from "./AudioManager";

export type DubbingManagerHandle = {
  onPlay: () => void;
  onPause: () => void;
  onSeek: () => void;
  onProgress: (videoProgress: OnProgressProps) => Promise<void>;
};

type Props = {
  videoRef: ReactPlayer;
  isDisabled?: boolean;
};

const DubbingManager = (
  { videoRef, isDisabled = false }: Props,
  ref: ForwardedRef<DubbingManagerHandle>,
) => {
  const audioManagerRef = useRef<AudioManagerHandle>(null);
  const { dubbings, setDubbings } = useHomeworkState();

  useImperativeHandle(
    ref,
    () => ({
      onPlay: () => audioManagerRef.current?.onPlay(),
      onPause: () => audioManagerRef.current?.onPause(),
      onSeek: () => audioManagerRef.current?.onSeek(),
      onProgress: async (progress) =>
        audioManagerRef.current?.onProgress(progress, 0.3),
    }),
    [],
  );

  return (
    <AudioManager
      audios={dubbings}
      setAudios={setDubbings}
      videoRef={videoRef}
      ref={audioManagerRef}
      isDisabled={isDisabled}
    />
  );
};

export default forwardRef(DubbingManager) as (
  props: Props & { ref?: Ref<DubbingManagerHandle> },
) => JSX.Element;
